import { Col, Layout } from "antd";
import React from "react";
const { Content } = Layout;

const Terms = (props) => {
  return (
    <Layout className="gx-app-layout">
      <Content>
        <Col sm={18} className="terms-container">
          <div
            className="gx-p-4 gx-pb-5"
            style={{ maxHeight: "100vh", overflowY: "auto" }}
          >
            <p>
              <b>
                Please Agree to the T&Cs Below for us to create a Transcription
                access account.{" "}
              </b>
            </p>
            <h1 className="gx-mb-4" style={{ textAlign: "center", fontWeight: 700 }}>
                SYSTEM ACCESS CONFIDENTIALITY AGREEMENT
            </h1>
            <p>
              In order for you to use the system owned and operated by DNA
              Solutions Australia Pty Ltd., you must read and accept this
              agreement, initial each page and sign at the end of this
              agreement.
            </p>
            <p>
              I/We accept full responsibility for the security and protection of
              identification and password codes, including (without limitation)
              the unique Patient Identification Number (“Patient ID”) issued to
              me/us for access to the DNA Solutions Group’s Information Systems.
              In order to protect the confidentiality of the information to
              which I am/we are now a party and to protect the privacy of the
              patient information to which we have access, I/we agree and
              acknowledge that:
            </p>
            <ol type="1">
              <p>
                {" "}
                <li>
                  The IT and computing facilities of DNA Solutions Australia are
                  only to be used for:-
                  <p>
                    <ol type="a">
                      <p>
                        <li>authorised and lawful purposes; and </li>
                        <li>
                          in connection with and in support of the approval and
                          authorized activities of the Practice / Hospital /
                          Organization.
                        </li>
                      </p>
                    </ol>
                  </p>
                </li>
              </p>
              <p>
                <li>
                  I/we will not access or use information in the computer system
                  which is not required within my/our day-to-day
                  responsibilities and in the duties of patient care and
                  treatment. I/we understand and acknowledge that, browsing
                  through patient records or accessing records that are not
                  required as part of my/our duty, is strictly prohibited
                  pursuant to privacy legislation, patient privacy rules and
                  compliance with work place confidentiality laws.
                </li>
              </p>
              <p>
                <li>
                  The Patient ID and the personal identification and password
                  code that is assigned to me/us are solely to facilitate
                  patient care and treatment. These codes and numbers must not
                  be shared with anyone else. I/we will take all precautions n
                  ecessary to protect the privileges assigned to me/us. If I/we
                  have any reason to believe that another person is aware of
                  my/our personal identification and password code or a Patient
                  ID, I/we must immediately notify DNA Solutions IT Support via
                  telephone on 1300306191 to change it.
                </li>
              </p>
              <p>
                <li>
                  I/we must not at any time access (or attempt to access),
                  alter, t ransfer or copy information in the computer system by
                  using another user or group identification code other than my
                  / our own. I/we must not alter or delete information in the
                  computer system. I/we must not use a Patient ID that I am/we
                  are not authorized to use.
                </li>
              </p>
              <p>
                <li>
                  I/we must not permit another person to access, alter,
                  transfer, c opy or delete information in the computer system
                  under my/our personal identification code, after I/we have
                  logged on to the system or at any other time.
                </li>
              </p>
              <p>
                <li>
                  It is my/our responsibility at all times, to logout of the
                  system when my/our work is complete or when I/we leave the
                  workstation. The system must not be allowed to remain open for
                  access by unauthorised persons at any time.
                </li>
              </p>
              <p>
                <li>
                  It is my/our responsibility to immediately report any
                  incidents or suspected incidents of improper, unauthorised or
                  illegal activity concerning the use of the Patient Information
                  System. Without limiting the generality of this obligation,
                  I/we must immediately report to DNA Solutions IT Support :
                  <ol type="a">
                    <li>
                      any access to or use of patient information that is not in
                      accordance with approved and authorised functions and
                      obligations of the Hospital/Practice;
                    </li>
                    <li>
                      the departure of any authorised person/user from the
                      Practice or group, so as to enable the access code to be
                      cancelled and a new one issued;
                    </li>
                    <li>
                      the admission to the Practice or group of any new user
                      requiring access to the Patient Information System;
                    </li>
                    <li>
                      the disclosure by any means, accidental or otherwise, of a
                      Patient ID to any unauthorized person or to any person who
                      is not bound by this agreement, so that the Patient ID may
                      be cancelled and a new one issued.
                    </li>
                  </ol>
                </li>
              </p>
              <p>
                <li>
                  I/We agree and acknowledge it is my/our responsibility to
                  respect patient privacy and to protect at all times the
                  confidentiality of information to which I/we have access.
                </li>
              </p>
              <p>
                <li>
                  I/We understand that access to this system is at no charge.
                  DNA Solutions and the Associated Groups are not responsible
                  for any costs incurred by the user, or for costs associated
                  with the user’s own internet connection including bandwidth
                  (uploads and downloads).
                </li>
              </p>
              <li>
                I/We will at all times act in accordance with the Privacy Act
                1988 (Commonwealth) (as amended) including the National Privacy
                Principles and the Australian Privacy Principles contained
                therein. Without limiting the generality of this essential
                obligation:
                <ol type="a">
                  <li>
                    I/we must not, without the informed consent of the patient:
                    <ul>
                      <li>
                        use or disclose personal information other than for the
                        primary purpose for which it is made available;
                      </li>
                      <li>
                        allow personal information to leave Australia; and
                      </li>
                    </ul>
                  </li>
                  <li>
                    I/we must take all reasonable steps to ensure that:
                    <ul>
                      <li>
                        personal information collected, used or disclosed is
                        accurate, current, complete and relevant;
                      </li>
                      <li>
                        personal information is protected from misuse,
                        interference, loss, and from unauthorised access,
                        modification or disclosure; and
                      </li>
                      <li>
                        personal information is destroyed when it is no longer
                        required for any authorised purpose; and
                      </li>
                    </ul>
                  </li>
                  <li>
                    I/we declare and certify that at all relevant times I/we
                    have obtained (where it is possible to do so) the informed
                    consent of the patient to access and use the patient’s
                    personal medical information and history.
                  </li>
                </ol>
              </li>
              <li>
                I/we may access patient information, images and studies even if
                I am/we are not the patient’s referring physician by using the
                Break-Glass facility of DNA Solutions PACS system. If I/we
                Break-Glass and use a Patient ID to gain access to that
                patient’s information and records, I/we certify that :
                <ol type="a">
                  <li>
                    I/we accept and will comply with the Break-Glass
                    Confidentiality Agreement, which is an on-screen essential
                    obligation for using the Break-Glass facility;
                  </li>
                  <li>
                    I am/we are treating the patient whose information and
                    records I/we access; and
                  </li>
                  <li>
                    c. I am/we are aware that access to patient information and
                    records is monitored by DNA Solutions systems administrator.
                  </li>
                </ol>
              </li>
              <li>
                I/We will indemnify and keep indemnified DNA Solutions Australia
                Pty Ltd, the Scanaptics associated Groups and any of their
                related and associated entities from all and any loss or damage,
                including legal costs, that they or any of them sustain at any
                time as a result, direct or otherwise, of a breach by me/us of
                the confidentiality and privacy provisions of this Agreement.
              </li>
              <li>
                DNA Solutions Australia Pty Ltd and the DNA associated Groups
                reserve the right, in their absolute and unfettered discretion,
                to deny access to their systems a nd stored information at any
                time without prior notice. Normally they would only do so if
                they believed, on reasonable grounds, that the confidentiality,
                privacy, and security of stored information may be compromised,
                or that information was used or may be used for an unlawful or
                unauthorized purpose.
              </li>
            </ol>
            <p>
              <b>
                I/We, the undersigned, agree to be bound by the terms and
                conditions of this agreement.
              </b>
            </p>
            <p>
              <strong>Signed for:</strong>
            </p>
          </div>
        </Col>
      </Content>
    </Layout>
  );
};
export default Terms;
